import flyerNotFound from '@/assets/flyer_not_found.png';
import styles from './FlyerDetailsRemoved.styles';
import { FlyerDetailsNavBar } from '../FlyerDetailsNavBar/FlyerDetailsNavBar';
import { ButtonPrimaryMedium } from '@/design-system';

interface Props {
  goToPreviousPage: () => void;
  goToExploreFlyers: () => void;
}

export const FlyerDetailsRemoved: React.FC<Props> = ({ goToPreviousPage, goToExploreFlyers }) => (
  <div className={styles.flyerRemovedPage}>
    <FlyerDetailsNavBar onClick={goToPreviousPage} iconPosition="right" />
    <div className={styles.flyerRemovedContainer}>
      <img src={flyerNotFound} width="328px" height="420px" alt="This flyer can not be found" />
      <div className={styles.flyerRemovedButton}>
        <ButtonPrimaryMedium onClick={goToExploreFlyers}>Explore All Flyers</ButtonPrimaryMedium>
      </div>
    </div>
  </div>
);
